import { useState } from "react";

import { Button } from "@newsela/angelou";
import {
  withTrackEvent,
  objectTypes,
  actionPrefixes,
  actionNames,
} from "@newsela/snitch";

import { ICheckForUnderstandingQuizAnswerOption } from "@/types/models/CheckForUnderstandingQuiz.interface";

const ButtonWithTrackEvent = withTrackEvent(Button);

export const RevealButton = ({
  setSubmittedAnswers,
  correctAnswer,
}: {
  setSubmittedAnswers: (
    answers: ICheckForUnderstandingQuizAnswerOption[],
  ) => void;
  correctAnswer: ICheckForUnderstandingQuizAnswerOption | undefined;
}) => {
  const [isRevealed, setIsRevealed] = useState(false);

  if (!correctAnswer) {
    // don't render the reveal button if we do not have the correct answer to reveal
    return null;
  }

  const toggleReveal = async () => {
    // set the submitted answers to the correct answer when clicking reveal
    setSubmittedAnswers(!isRevealed ? [correctAnswer] : []);

    setIsRevealed(!isRevealed);
  };

  return (
    <ButtonWithTrackEvent
      actionPrefix={isRevealed ? actionPrefixes.initiate : actionPrefixes.undo}
      actionName={actionNames.hide}
      dataProps={{
        "data-qa-selector": "checks_for_understanding_answer_reveal_button",
      }}
      flavor={Button.flavors.primary}
      isFullWidth
      objectType={objectTypes.quizAnswer}
      onClick={() => {
        void toggleReveal();
      }}
    >
      {isRevealed ? "Hide answer" : "Show answer"}
    </ButtonWithTrackEvent>
  );
};
